@if (hasChildren()) {
  <div
    class="nav-item nav-item-expandable"
    [class.nav-item-expanded]="isExpanded()"
    [style.--depth]="depth()"
    (click)="toggleExpand()"
  >
    <span class="nav-label">{{ label() }}</span>
    <span class="material-symbols-outlined nav-chevron">expand_more</span>
  </div>
  <div
    class="nav-children"
    [class.nav-children-open]="isExpanded()"
    [style.--depth]="depth()"
  >
    <div class="nav-children-inner">
      @for (child of item().children; track child.id) {
        <app-sidebar-nav-group
          [item]="child"
          [depth]="childDepth()"
          [favoriteIds]="favoriteIds()"
          [siblingIds]="childIds(item().children)"
        />
      }
    </div>
  </div>
} @else if (hasValidRoute()) {
  <a
    class="nav-item nav-item-leaf"
    [style.--depth]="depth()"
    [routerLink]="item().angularPath ? 'app/' + item().angularPath : ['/gx', item().systemName]"
    routerLinkActive="nav-item-active"
    queryParamsHandling="preserve"
  >
    <span class="nav-label">{{ label() }}</span>
    <button
      class="favorite-btn"
      [class.favorited]="isFavorited()"
      (click)="toggleFavorite($event)"
    >
      <span class="material-symbols-outlined">favorite</span>
    </button>
  </a>
}
